"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@local/ui/src/components/uiv7/Button";
import { ShoppingCartIcon } from "./ShoppingCartIcon";
import { CallToAction, getInitialCtaString } from "./CallToAction";
import { Suspense, useMemo } from "react";
import { Link } from "@local/ui/src/components/ui/Link";
import { useSearchParams } from "next/navigation";
import { trackAction } from "@local/tracking/src/trackActions";
import { rebuildUrlParams, stripForcedTrackingParams } from "@local/utils/src/rebuildUrlParams";
import type { Offer } from "../../../types";
interface Props {
  callToAction?: string | null;
  isMirror?: boolean;
  noIcon?: boolean;
  skipView?: boolean;
  bigButton?: boolean;
  market: string;
  channel: string;
  mirrorUrl?: string;
  product?: Offer.PinProduct;
  prices?: Offer.ListingPrices;
}
export interface BtnBuyProps extends Props {
  full?: boolean;
  callToActionId?: string;
}
interface CtaProps {
  callToAction?: string | null;
  discount?: number;
}
const Cta = t0 => {
  const $ = _c(11);
  const {
    callToAction,
    discount
  } = t0;
  let t1;
  if ($[0] !== callToAction || $[1] !== discount) {
    t1 = getInitialCtaString(callToAction, "Select Size Now", discount);
    $[0] = callToAction;
    $[1] = discount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== callToAction || $[6] !== discount) {
    t3 = <CallToAction input={callToAction} action="Select Size Now" discount={discount} />;
    $[5] = callToAction;
    $[6] = discount;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <><Suspense fallback={t2}>{t3}</Suspense></>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const BtnBuyInner = t0 => {
  const $ = _c(58);
  const {
    callToAction,
    full,
    bigButton,
    market,
    channel,
    mirrorUrl,
    product,
    prices,
    callToActionId
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("item_id");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const itemId = t1;
  let t2;
  bb0: {
    if (!product) {
      t2 = undefined;
      break bb0;
    }
    const originalPrice = prices?.[0]?.value ?? product.msrp;
    const rawDiscount = prices?.[0]?.discountValue;
    const defaultDiscountPrice = rawDiscount && rawDiscount > 0 ? rawDiscount : originalPrice;
    let matchedModifierPrice;
    let hasSpecificSkuMatch = false;
    if ($[2] !== itemId || $[3] !== prices || $[4] !== product.skuLists || $[5] !== product.skus || $[6] !== product.type) {
      const allSkus = product.type === "BUNDLE" ? product.skuLists.flatMap(_temp) : product.skus;
      const matchingSku = itemId ? allSkus.find(sku => sku?.legacyId === itemId || sku.attributes.some(attr => attr.name === "payloadId" && attr.value === itemId) || sku.id === itemId || sku.name === itemId) : allSkus.find(_temp2);
      if (matchingSku) {
        hasSpecificSkuMatch = true;
        if (matchingSku.name && prices?.[0]?.modifiers?.length) {
          const matchedModifier = prices[0].modifiers.find(modifier => modifier.skus.includes(matchingSku.name as string));
          if (matchedModifier) {
            matchedModifierPrice = matchedModifier.amount;
          }
        }
      }
      $[2] = itemId;
      $[3] = prices;
      $[4] = product.skuLists;
      $[5] = product.skus;
      $[6] = product.type;
      $[7] = hasSpecificSkuMatch;
      $[8] = matchedModifierPrice;
    } else {
      hasSpecificSkuMatch = $[7];
      matchedModifierPrice = $[8];
    }
    let discountPrice;
    if (hasSpecificSkuMatch) {
      discountPrice = matchedModifierPrice ?? defaultDiscountPrice;
    } else {
      let t3;
      if ($[9] !== prices) {
        t3 = prices?.[0]?.modifiers?.length ? prices[0].modifiers.reduce(_temp3, prices[0].modifiers[0].amount) : undefined;
        $[9] = prices;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      const lowestModifierPrice = t3;
      discountPrice = lowestModifierPrice && lowestModifierPrice < defaultDiscountPrice ? lowestModifierPrice : defaultDiscountPrice;
    }
    let t3;
    if ($[11] !== discountPrice || $[12] !== originalPrice) {
      t3 = Math.round((originalPrice - discountPrice) / originalPrice * 100);
      $[11] = discountPrice;
      $[12] = originalPrice;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    t2 = t3;
  }
  const discount = t2;
  let checkoutUrl = channel === "store" ? `/${market}/checkout` : `/${market}/lp/${channel}/checkout`;
  if (itemId) {
    checkoutUrl = `${checkoutUrl}?item_id=${itemId}`;
  }
  if (mirrorUrl) {
    let t3;
    let t4;
    if ($[14] !== mirrorUrl || $[15] !== searchParams) {
      const url = new URL(mirrorUrl);
      const baseDomain = url.origin;
      const path = url.pathname;
      t3 = baseDomain;
      t4 = rebuildUrlParams(stripForcedTrackingParams(searchParams), path);
      $[14] = mirrorUrl;
      $[15] = searchParams;
      $[16] = t3;
      $[17] = t4;
    } else {
      t3 = $[16];
      t4 = $[17];
    }
    checkoutUrl = `${t3}${t4}`;
  }
  const checkoutUrl_0 = checkoutUrl;
  let t3;
  if ($[18] !== callToActionId || $[19] !== channel || $[20] !== checkoutUrl_0) {
    t3 = () => {
      trackAction("cta_click", {
        component: "BtnBuy",
        destination: checkoutUrl_0,
        channel,
        cta_id: callToActionId ?? null
      });
    };
    $[18] = callToActionId;
    $[19] = channel;
    $[20] = checkoutUrl_0;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  const handleCtaClick = t3;
  if (bigButton) {
    let t4;
    if ($[22] !== callToAction || $[23] !== discount) {
      t4 = <Cta callToAction={callToAction} discount={discount} />;
      $[22] = callToAction;
      $[23] = discount;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    let t5;
    if ($[25] !== callToActionId || $[26] !== checkoutUrl_0 || $[27] !== handleCtaClick || $[28] !== t4) {
      t5 = <Button as="link" variant="primary" href={checkoutUrl_0} id={callToActionId} prefetch={true} data-cta="true" onClick={handleCtaClick} className="mx-auto my-4 w-full min-w-[75%] text-xl font-bold uppercase sm:w-auto sm:px-8 sm:text-2xl md:w-full lg:min-w-full xl:min-w-[75%]">{t4}</Button>;
      $[25] = callToActionId;
      $[26] = checkoutUrl_0;
      $[27] = handleCtaClick;
      $[28] = t4;
      $[29] = t5;
    } else {
      t5 = $[29];
    }
    return t5;
  }
  if (full) {
    let t4;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ShoppingCartIcon className="block h-8 max-h-[35px] w-8 max-w-[35px]" aria-hidden="true" />;
      $[30] = t4;
    } else {
      t4 = $[30];
    }
    let t5;
    if ($[31] !== callToAction || $[32] !== discount) {
      t5 = <span data-cy="buy-button" className="w-full"><Cta callToAction={callToAction} discount={discount} /></span>;
      $[31] = callToAction;
      $[32] = discount;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    let t6;
    if ($[34] !== callToActionId || $[35] !== checkoutUrl_0 || $[36] !== handleCtaClick || $[37] !== t5) {
      t6 = <Button as="link" variant="primary" href={checkoutUrl_0} id={callToActionId} prefetch={true} data-cta="true" onClick={handleCtaClick} className="my-2 flex w-full items-center gap-2 text-lg font-bold uppercase md:hidden">{t4}{t5}</Button>;
      $[34] = callToActionId;
      $[35] = checkoutUrl_0;
      $[36] = handleCtaClick;
      $[37] = t5;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    return t6;
  }
  const t4 = callToAction || "Buy now";
  let t5;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ShoppingCartIcon className="block h-5 w-5 md:mr-2" aria-hidden="true" />;
    $[39] = t5;
  } else {
    t5 = $[39];
  }
  let t6;
  if ($[40] !== callToAction || $[41] !== discount) {
    t6 = <span data-cy="buy-button"><Cta callToAction={callToAction} discount={discount} /></span>;
    $[40] = callToAction;
    $[41] = discount;
    $[42] = t6;
  } else {
    t6 = $[42];
  }
  let t7;
  if ($[43] !== callToActionId || $[44] !== checkoutUrl_0 || $[45] !== handleCtaClick || $[46] !== t4 || $[47] !== t6) {
    t7 = <Button as="link" variant="primary" size="sm" href={checkoutUrl_0} id={callToActionId} prefetch={true} data-cta="true" onClick={handleCtaClick} aria-label={t4} className="font-display hidden font-black uppercase md:inline-flex">{t5}{t6}</Button>;
    $[43] = callToActionId;
    $[44] = checkoutUrl_0;
    $[45] = handleCtaClick;
    $[46] = t4;
    $[47] = t6;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  const t8 = callToActionId ? `${callToActionId}-mobile` : undefined;
  const t9 = callToAction || "Buy now";
  let t10;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ShoppingCartIcon className="block h-8 w-8 md:mr-2 md:h-5 md:w-5" aria-hidden="true" />;
    $[49] = t10;
  } else {
    t10 = $[49];
  }
  let t11;
  if ($[50] !== checkoutUrl_0 || $[51] !== handleCtaClick || $[52] !== t8 || $[53] !== t9) {
    t11 = <div className="block p-4 md:hidden"><Link href={checkoutUrl_0} id={t8} className="hover:cursor-pointer hover:no-underline" prefetch={true} data-cta="true" onClick={handleCtaClick} aria-label={t9}>{t10}</Link></div>;
    $[50] = checkoutUrl_0;
    $[51] = handleCtaClick;
    $[52] = t8;
    $[53] = t9;
    $[54] = t11;
  } else {
    t11 = $[54];
  }
  let t12;
  if ($[55] !== t11 || $[56] !== t7) {
    t12 = <div className="flex items-center p-4!">{t7}{t11}</div>;
    $[55] = t11;
    $[56] = t7;
    $[57] = t12;
  } else {
    t12 = $[57];
  }
  return t12;
};
export const BtnBuy = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense><BtnBuyInner {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(skuList) {
  return skuList.skus;
}
function _temp2(sku_0) {
  return sku_0.isPreselected === true;
}
function _temp3(min, m) {
  return m.amount < min ? m.amount : min;
}